import React, { useState } from 'react';

const VideoPlayer = ({ url }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  // Helper to extract video ID from YouTube URL
  const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };
  
  // Helper to extract video ID from Vimeo URL
  const getVimeoVideoId = (url) => {
    const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    const match = url.match(regExp);
    return match ? match[5] : null;
  };
  
  // Prepare embed URL based on video platform
  const getEmbedUrl = () => {
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = getYouTubeVideoId(url);
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    } else if (url.includes('vimeo.com')) {
      const videoId = getVimeoVideoId(url);
      return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
    }
    return null;
  };
  
  const embedUrl = getEmbedUrl();
  
  const handleIframeLoad = () => {
    setLoading(false);
  };
  
  const handleIframeError = () => {
    setError(true);
    setLoading(false);
  };
  
  if (!embedUrl) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-gray-100">
        <div className="text-sm text-gray-500">
          Unsupported video URL format. Please use YouTube or Vimeo.
        </div>
      </div>
    );
  }
  
  return (
    <div className="relative w-full h-full" style={{ display: 'block' }}>
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {error && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="text-sm text-red-500">
            Failed to load video. Please try again later.
          </div>
        </div>
      )}
      <iframe
        src={embedUrl}
        className="absolute top-0 left-0 w-full h-full"
        style={{ width: '100%', height: '100%', border: 'none' }}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        onLoad={handleIframeLoad}
        onError={handleIframeError}
      ></iframe>
    </div>
  );
};

export default VideoPlayer; 